export enum MedicalPersonalDiseaseControlEnum {
  WELL = 'WELL',
  FAIR = 'FAIR',
  BAD = 'BAD'
}
